import { Type } from "@themes/pollinator/ui/Type";
import { useDialog } from "@platform/store";
import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { MarketingAbout } from "@platform/features/marketing";

export function AboutPage() {
  const { openDialog } = useDialog();

  return (
    <OuterContentContainer
      className="flex-1 flex flex-col items-center justify-center"
      innerClassName="flex-1 gap-8 py-8 md:py-0"
    >
      <Type as="h1" variant="h2">
        About Pollinator
      </Type>
      <MarketingAbout onHireUsClick={() => openDialog("hireUs")} />
    </OuterContentContainer>
  );
}

export default AboutPage;


